module.exports = __webpack_public_path__ + "img/cloud-bolt-sun.55ba10e6.svg";